export default "__VITE_ASSET__DsG2Xo7v__"